import { ENVIROMENT } from '../../src/components/customUtils/AppConstants'
const CONFIG_IP_LOCAL = '192.168.1.52'
const CONFIG_IP_LOCAL_M = '192.168.0.168'

export const CONFIG_IP_TEST = '34.207.229.228'

const RELEASE = 'v2'
export const TEST = 'testing'

export const VERSION_DATABASE = 55 //Si se sube la version, descomentar tablas sensibles de indexDB

// ⚡ PERFORMANCE MONITOR - Activar/Desactivar sistema de monitoreo
// true = Activo (para testing/development)
// false = Desactivado (para producción final)
export const PERFORMANCE_MONITOR_ENABLED = true

export const apiUrl = `https://${RELEASE}-${ENVIROMENT}.1onesolutions.com`
// export const apiUrl = `https://${TEST}-${ENVIROMENT}.1onesolutions.com`
// export const apiUrl = 'http://192.168.0.14:3002'

// export const apiUrl = `http://${CONFIG_IP_LOCAL}:3002`
export const apiUrlWSocket = 'wss://18.189.12.199:8089'
// export const apiUrlWSocket = 'wss://1in97lxafi.execute-api.us-east-1.amazonaws.com/dev?name_group=one_sky&user=661ea24dc260f7be6fc89b3b&device=105ef1d633bea7ee'
export const baseURLWSocket = 'wss://1in97lxafi.execute-api.us-east-1.amazonaws.com/dev'
